(function () {
	const mediaBanner = () => {
		document.querySelectorAll(".media-banner").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);

			const stickyEffect = block.data("sticky-effect");

			if (stickyEffect) {
				var normalElement = document.querySelector(`#${id} + .sticky-section`);
				if (normalElement == null) {
					return;
				}

				var isSticky = false;

				window.addEventListener("scroll", function () {
					var stickyTop = box.getBoundingClientRect().top;
					var normalElementTop = normalElement.getBoundingClientRect().top;

					if (stickyTop <= 0 && !isSticky) {
						box.classList.add("sticky-active");
						isSticky = true;
					}

					if (normalElementTop <= 0 && isSticky) {
						box.classList.remove("sticky-active");
						isSticky = false;
					}
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		mediaBanner();
		document.addEventListener("shopify:section:load", function () {
			mediaBanner();
		});
	});
})();
(function() {
  // 1. Immediate Mobile Check: Exit early if desktop or if the bar is disabled globally
  if (window.innerWidth > 1023) return;

  const initHintBar = () => {
    const slide = document.querySelector('.media-banner__slide');
    const bar = document.querySelector('.hintScrollBar');
    
    // Safety check: if the elements don't exist on the current page, stop here
    if (!slide || !bar) return;

    let hintTimer;
    let isKilled = false;

    const runLoop = (show) => {
      if (isKilled || window.scrollY > 20) {
        slide.classList.remove('cssHintBarVisible');
        return;
      }

      if (show) {
        slide.classList.add('cssHintBarVisible');
        hintTimer = setTimeout(() => runLoop(false), 3000);
      } else {
        slide.classList.remove('cssHintBarVisible');
        hintTimer = setTimeout(() => runLoop(true), 3000);
      }
    };

    // 2. Generous Delay: Wait 4 seconds after page load so the video stabilizes
    setTimeout(() => {
      if (!isKilled && window.scrollY <= 10) {
        runLoop(true);
      }
    }, 4000);

    // Optimized scroll listener
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10 && !isKilled) {
        isKilled = true;
        clearTimeout(hintTimer);
        slide.classList.remove('cssHintBarVisible');
      }
    }, { passive: true });
  };

  // 3. Heavy Load Protection: Wait until everything (video, heavy assets) is fully loaded
  if (document.readyState === 'complete') {
    initHintBar();
  } else {
    window.addEventListener('load', initHintBar);
  }
})();